import React, {useEffect} from 'react';
import ComponentList from '../components/ComponentList';
import ProductHero from '../components/ProductHero';
import ProductReviews from '../components/ProductReviews';
import Seo from '../components/Seo';
import ProductSchema from '../components/ProductSchema';
import KlaviyoProductTracking from '../components/KlaviyoProductTracking';
import {centsToPrice} from '../utils/filters';
import app from '../utils/app';

export default ({
	pageContext,
	location,
}) => {
	const { product = {}, notifyMeCta, priceMatchCta, priceMatchDescription, guaranteeTitle, guaranteeColumns = [] } = pageContext;
	const {seo = {}} = product;

	const metaTitle = seo.metaTitle || `${product.title} | Teddy Baldassarre`;
	const openGraphTitle = seo.openGraphTitle || `${product.title} | Teddy Baldassarre`;
	const openGraphImage = seo.openGraphImage || product.mainImage;
	const twitterTitle = seo.twitterTitle || `${product.title} | Teddy Baldassarre`;
	const twitterImage = seo.twitterImage || product.mainImage;

	// Track product view only once
	useEffect(() => {
		if (app.analytics) {
			app.analytics.viewProduct({
				id: product.variants[0].sku,
				name: product.title,
				brand: product.brand ? product.brand.map(b => b.title).join(', ') : 'Teddy Baldassarre',
				category: 'Watches',
				variant:product.variants[0].title,
				quantity: 1,
				price: product.variants[0].cents / 100,
			});
		}
	}, [0]);

	return (
		<React.Fragment>
			<Seo
				metaTitle={metaTitle}
				metaDescription={seo.metaDescription}
				metaKeywords={seo.metaKeywords}
				openGraphTitle={openGraphTitle}
				openGraphDescription={seo.openGraphDescription}
				openGraphImage={openGraphImage}
				twitterTitle={twitterTitle}
				twitterDescription={seo.twitterDescription}
				twitterImage={twitterImage}
				pathname={location.pathname}
			/>
			<ProductSchema
				name={product.title}
				image={product.mainImage ? product.mainImage.url : undefined}
				description={seo.metaDescription}
				sku={product.variants[0].sku}
				price={(product.variants[0].cents / 100).toFixed(2)}
				url={`https://teddybaldassarre.com${location.pathname}`}
				brandName={product.brand ? product.brand.map(b => b.title).join(', ') : undefined}
			/>
			<KlaviyoProductTracking
				title={product.title}
				id={product._id}
				image={product.mainImage ? product.mainImage.url : undefined}
				url={`https://teddybaldassarre.com${location.pathname}`}
				brandName={product.brand ? product.brand.map(b => b.title).join(', ') : undefined}
				price={centsToPrice(product.variants[0].cents)}
			/>
			<ProductHero
				productId={product.productId}
				brand={product.brand}
				title={product.title}
				cents={product.cents}
				compareAtCents={product.compareAtCents}
				variants={product.variants}
				optionDropdowns={product.optionDropdowns}
				notifyMeCta={notifyMeCta}
				priceMatchCta={!product.disablePriceMatch ? priceMatchCta : null}
				priceMatchDescription={!product.disablePriceMatch ? priceMatchDescription : null}
				enableAuthorizedDealer={product.enableAuthorizedDealer}
				authorizedDealerTitle={product.authorizedDealerTitle}
				authorizedDealerSubtitle={product.authorizedDealerSubtitle}
				authorizedDealerLogo={product.authorizedDealerLogo}
				guaranteeTitle={guaranteeTitle}
				guaranteeColumns={guaranteeColumns}
			/>
			<div id='details'>
				<ComponentList components={product.components} />
			</div>
			<ProductReviews
				productId={product.productId}
				productTitle={product.title}
				productUrl={location.href}
				reviews={pageContext.reviews}
				bottomLine={pageContext.bottomLine}
			/>
		</React.Fragment>
	);
};